module.exports = __webpack_public_path__ + "static/media/joyce-prof.3e28864d.svg";